'use client';

import React from 'react';
import { faqItems, ICONS } from './faqs';

const FAQ: React.FC = () => {
  return (
    <section className="py-2">
      <div className="max-w-7xl mx-auto px-0">
        <div className="py-0 px-6">
          <p
            className="text-center font-bold text-sm mt-2 text-primary/80"
            style={{ color: 'black' }}
          >
            Here are some of the frequently asked questions
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 xl:gap-12 px-2 xl:px-12 mt-6">
            {faqItems.map((item, idx) => {
              const Icon = item.icon ? ICONS[item.icon] : ICONS['services'];
              return (
                <article key={idx} className="flex gap-6 mt-6">
                  <div className="shrink-0">
                    <Icon
                      className="h-6 w-6 text-primary"
                      style={{ color: 'var(--color-primary)' }}
                      aria-hidden="true"
                    />
                  </div>

                  <div>
                    <h5
                      className="text-xl font-bold text-black"
                      style={{ color: 'black' }}
                    >
                      {item.title}
                    </h5>

                    <p
                      className="my-2 text-sm text-primary/80"
                      style={{ color: 'black' }}
                    >
                      {item.body}
                    </p>

                    {item.href && (
                      <a
                        href={item.href}
                        className="capitalize hover:underline transition-opacity text-primary"
                        style={{ color: 'black' }}
                      >
                        Read More
                      </a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
